export const INITIAL_STATIC_DATA = { values: [] };
